export const sendNewPlanToAnalytics = (planDetails) => {
    window.gtag &&
    window.gtag("event", "purchase", {
        event_category: "engagement",
        event_label: planDetails.name,
        value: planDetails.price,
    });
    window.fbq &&
    window.fbq("trackSingle", "668158800558412", "Subscribe", {
        value: planDetails.price,
        currency: "USD",
        predicted_ltv: planDetails.price * 12,
    });
};

export const sendNewSegmentToAnalytics = () => {
    window.gtag &&
    window.gtag("event", "start trial", {
        event_category: "engagement",
    });
    window.fbq &&
    window.fbq("trackSingle", "668158800558412", "StartTrial", {
        value: "69.00",
        currency: "USD",
        predicted_ltv: "828.00",
    });
};

export const sendPageViewEvent = (data) => {
    if(window.gtag) {
        window.gtag("event", "page_view", data);
    }
}

export const trackSingle = (data) => {
    if(window.fbq) {
        window.fbq("trackSingle", "668158800558412", "ViewContent", data);
    }
}